'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;
exports['default'] = ListItemSecondaryAction;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListItemSecondaryAction', function (theme) {
  return {
    secondaryAction: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: '-' + theme.typography.rhythmByUnit(3)
    }
  };
});

function ListItemSecondaryAction(props, context) {
  var children = props.children,
      classNameProp = props.className;

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.secondaryAction, classNameProp);

  return _react2['default'].createElement(
    'div',
    { className: className },
    children
  );
}

ListItemSecondaryAction.displayName = 'ListItemSecondaryAction';

ListItemSecondaryAction.propTypes = {
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string
};

ListItemSecondaryAction.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ListItemSecondaryAction.js
// module id = 639
// module chunks = 32